import { apiClient, ApiResponse } from './client'

export interface LoginRequest {
  email: string
  password: string
  deviceFingerprint?: string | null
}

export interface RegisterRequest {
  email: string
  password: string
  fullName: string
}

export interface AuthUser {
  id: number
  email: string
  fullName: string
  role?: string
  canAccessAdmin?: boolean
  canAccessLearner?: boolean
  isDualRole?: boolean
  isLcOwner?: boolean
  lcPermissions?: string[]
  phoneNumber?: string | null
  countryCode?: string | null
  isPhoneVerified?: boolean
}

export interface DeviceContext {
  isRegistered: boolean
  deviceId: string | null
  attendanceUpdated: boolean
}

export interface AuthResponse {
  user: AuthUser
  accessToken: string
  refreshToken: string
  deviceContext?: DeviceContext
}

export interface LogoutResponse {
  success: true
  attendanceUpdated: boolean
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
}

export type ChangePasswordErrorCode =
  | 'INVALID_CURRENT_PASSWORD'
  | 'WEAK_PASSWORD'
  | 'SAME_AS_CURRENT_PASSWORD'

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<ApiResponse<AuthResponse>>('/auth/login', data),

  register: (data: RegisterRequest) =>
    apiClient.post<ApiResponse<AuthUser>>('/auth/register', data),

  logout: () =>
    apiClient.post<ApiResponse<LogoutResponse>>('/auth/logout'),

  me: () =>
    apiClient.get<ApiResponse<AuthUser & { deviceContext?: DeviceContext }>>('/auth/me'),

  refresh: (refreshToken: string) =>
    apiClient.post<ApiResponse<AuthResponse>>('/auth/refresh', { refreshToken }),

  changePassword: (data: ChangePasswordRequest) =>
    apiClient.put<ApiResponse<{ message: string }>>('/auth/password', data),

  updateProfile: (data: { fullName: string }) =>
    apiClient.patch<ApiResponse<AuthUser & { deviceContext?: DeviceContext }>>('/auth/me', data),
}

